import { TextField, Button, Box, Container, Divider, Select, MenuItem, ListItem, List, ListItemButton } from "@mui/material";
import { useState } from "react"
import { useTranslation } from "react-i18next";
import { getApiError, getService } from "../../app/api";
import { AuthService, UserService } from "../../api/services";
import style from './Settings.module.css'
import { useSnackbar } from "notistack";
import session from "../../app/Session";

export default function Settings(){
  const { t, i18n } = useTranslation();           
  let[ action, setAction] = useState<string|null>(null);
  const actions = ["authorize", "generate-url", "invite"];
  return (
    <Container className={style.root}>
      <Box className={style.actions}>
      <List>
        { actions.map((value) => (
          <ListItem
            key={value}
            disableGutters>
            <Button  variant="outlined" onClick={(e)=>setAction(e.currentTarget.getAttribute('data-val'))} data-val={value} >{t(value)}</Button>
          </ListItem>
        ))}
      </List>
      </Box>
      <Box className={style.actions_content}>
        {action === "authorize" && <DeviceCodeAuthorize />}
        {action === "generate-url" && <GenerateAuthenticatedUrl />}
        {action === "invite" && <InviteMember />}       
      </Box>  
    </Container>
  )
}

function DeviceCodeAuthorize(){
  const { t, i18n } = useTranslation();   
  let [code, setCode] = useState("")

  const onAuthorizeCode = async()=>{
    await getService(AuthService).authorizeDevice({code});
  }

  return (  
    <div className={style.action_content_root}>
      <h4>{t('Device Code')}</h4>
      <Box>
        <TextField
              required
              style={{fontSize:'large'}}
              label={t("Device Code")}             
              variant="outlined"
              aria-aria-readonly={true}
              fullWidth={true}
              onChange={(e)=>setCode(e.target.value)}
              value={code} />
      </Box>
      <Box style={{marginTop:'.5rem'}}>         
        <Button variant="outlined" onClick={onAuthorizeCode} fullWidth={true}> {t('Authorize Code')} </Button>
      </Box> 
      </div>
  )
}

function GenerateAuthenticatedUrl(){
  const { t, i18n } = useTranslation();   
  let [email, setEmail] = useState("")
  let [link, setLink] = useState("")
  const { enqueueSnackbar } = useSnackbar();

  const onAuthorizeCode = async()=>{
    let res = await getService(AuthService).getAuthCode({email});
    if(!res.url){
      enqueueSnackbar(t('Action failed'), { variant: 'error' });
      return;
    }

    setLink(res.url);
  }
  return (
    <div className={style.action_content_root}>
      <h4>{t('Generate Access Url')}</h4>
    <Box>
      <TextField
            required
            style={{fontSize:'large'}}
            label={t("Email")}             
            variant="outlined"
            aria-aria-readonly={true}
            onChange={(e)=>setEmail(e.target.value)}
            fullWidth={true}
            value={email} />
    </Box>
    <Box style={{marginTop:'.5rem'}}>         
      <Button variant="outlined" onClick={onAuthorizeCode} fullWidth={true} > {t('Generate URL')} </Button>
    </Box>
    <Box style={{marginTop:'.5rem'}}>
      <TextField 
        style={{fontSize:'large'}}
        label={t("Url")}             
        variant="outlined"
        aria-aria-readonly={true}        
        value={link} 
        fullWidth={true}
         />
    </Box> 
    </div> 
  )

}

function InviteMember(){
  const { t, i18n } = useTranslation();   
  let [email, setEmail] = useState("")
  let [role, setRole] = useState("member")
  const { enqueueSnackbar } = useSnackbar();

  const onInvite = async()=>{
    try{
      await getService(UserService).inviteUser({email, role});    
      enqueueSnackbar(t('Invite created'), { variant: 'success' });
    }catch(e){
      enqueueSnackbar(t('Action failed: : {{error}}',{ error:getApiError(e) }), { variant: 'error' });
    }
  }

  return (  
    <div className={style.action_content_root}>
       <h4>{t('Invite Member')}</h4>
      <Box>
        <TextField
              required
              style={{fontSize:'large'}}
              label={t("email")}             
              variant="outlined"
              aria-aria-readonly={true}
              fullWidth={true}
              onChange={(e)=>setEmail(e.target.value)}
              value={email} />
      </Box>
      <Box style={{marginTop:'.5rem'}}>       
          <label>{t('Role')}</label><br/>
          <Select label="Role" value={role} onChange={(e)=>setRole(e.target.value)} fullWidth={true} variant="outlined" >            
            <MenuItem  value="member">{t('Member')}</MenuItem >
            <MenuItem  value="guest">{t('Guest')}</MenuItem >
            <MenuItem  value="owner">{t('Owner')}</MenuItem >
          </Select>
      </Box>
      <Box style={{marginTop:'.5rem'}}>         
        <Button variant="outlined" onClick={onInvite} fullWidth={true}> {t('Invite user')} </Button>
      </Box> 
      </div>
  )
}